// extracted by mini-css-extract-plugin
export default {"legacyContent":"legacyContent-n7IT1AfU"};